import {Component, inject, OnInit, signal} from '@angular/core';
import {DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../shared/not-found/not-found.component";
import {AsyncLoadingComponent} from '../../shared/async-loading/async-loading.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  ManufacturerDto,
  Page,
  QrCodeSearchParam,
  QrCodeStatus,
  QrCodeStatusArray, QrCodeView
} from '../../../generated-model/model';
import {SharedCommonModule} from '../../shared/shared-common.module';
import {QrCodeRest} from '../../service/QrCodeRest';
import {IgnoreNullHttpParams} from '../../shared/Ignore-null-http-params';
import {filter} from 'rxjs/operators';
import {
  ManufacturerAutocompleteComponent
} from '../../shared/components/manufacturer-autocomplete/manufacturer-autocomplete.component';
import {GtNgDatepickerModule} from '../../shared/gt-ng-datepicker/gt-ng-datepicker.module';
import {Router} from '@angular/router';

@Component({
  selector: 'app-manager-qrcode',
  standalone: true,
  imports: [
    DecimalPipe,
    NgForOf,
    NgIf,
    NgbPagination,
    AsyncLoadingComponent,
    NotFoundComponent,
    ReactiveFormsModule,
    SharedCommonModule,
    FormsModule,
    ManufacturerAutocompleteComponent,
    GtNgDatepickerModule
  ],
  templateUrl: './manager-qrcode.component.html',
  styleUrl: './manager-qrcode.component.scss'
})
export class ManagerQrcodeComponent implements OnInit {
  pageData: Page<QrCodeView> = {size: 10};
  isLoading = false;
  manufacturerSelected = signal(undefined as ManufacturerDto)
  searchParam: QrCodeSearchParam & { page?: number } = {}
  private router = inject(Router);

  qrCodeRest = inject(QrCodeRest)

  ngOnInit(): void {
    this.search()
  }

  search(page: number = 1) {
    this.isLoading = true;
    this.searchParam.manufacturer = this.manufacturerSelected() ? this.manufacturerSelected().businessName : undefined
    let param = IgnoreNullHttpParams.fromObject({...this.searchParam})
      .set('page', page - 1)
      .set('size', this.pageData.size)
      .set('sort', 'createdDate,desc')
    this.qrCodeRest.searchAdmin(param).pipe(filter(e => !!e)).subscribe({
      next: e => {
        this.pageData = e
      },
      error: () => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  protected readonly QrCodeStatus = QrCodeStatus;
  protected readonly QrCodeStatusArray = QrCodeStatusArray;

  clear() {
    this.searchParam = {}
    this.manufacturerSelected.set(undefined)
    this.search()
  }

  openDetail(item: QrCodeView) {
    if (!item.id || !item.uuid) {
      return;
    }
    const url = this.router.serializeUrl(this.router.createUrlTree(['/p', item.id, item.uuid]));
    window.open(url, '_blank');
  }

  isStatusLinkEnabled(item: QrCodeView) {
    return !['PRE_QRCODE', 'WAIT_QRCODE', 'WAIT_SAVE_PRE_QRCODE'].includes(item.qrCodeStatus ?? '') && !!item.id && !!item.uuid;
  }
}
